import { render, staticRenderFns } from "./CourseIndexAgenda.vue?vue&type=template&id=39d4bc4a&scoped=true&"
import script from "./CourseIndexAgenda.vue?vue&type=script&lang=js&"
export * from "./CourseIndexAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4bc4a",
  null
  
)

export default component.exports